import type { ModelUsageDetail } from '../../../utils/openai-api';
import { isOpenAiWebRunUsage, OPENAI_WEB_SEARCH_COST_MODEL } from '../../../utils/openai-api/web-search';

/** Presentation units must never change numberOfRequests or the dashboard request total. */
export function getModelUsageDisplay(model: ModelUsageDetail) {
  const isSearchCharge = model.provider === 'openai' && model.model === OPENAI_WEB_SEARCH_COST_MODEL;
  const isSearchActivity = model.provider === 'openai' && isOpenAiWebRunUsage(model.model, 'completions');
  return {
    isSearchCharge,
    isSearchActivity,
    quantity: isSearchCharge ? model.webSearchCalls ?? null : model.numberOfRequests,
    unit: isSearchCharge ? 'searches' : isSearchActivity ? 'runs' : '',
    description: isSearchCharge ? 'Search tool charges' : isSearchActivity ? 'Search activity · charged separately' : '',
  };
}
